import { inject, InjectionToken } from "@angular/core";
import { DebugConfig } from "../models/debug-config.model";

/**
 * Provides Injection Token for DebugConfig object
 */
export const DEBUG_CONFIG = new InjectionToken<DebugConfig|undefined>('DEBUG_CONFIG');
